import { DotsIcon } from "@/components/icon";
import Box from "@/components/icon/Box.icon";
import ShakingHands from "@/components/icon/ShakingHands.icon";

const documentsTabElements = [
  {
    key: "agreement",
    tabLabel: "Agreements",
    tabIcon: <ShakingHands />,
  },
  {
    key: "product",
    tabLabel: "Products",
    tabIcon: <Box />,
  },
  {
    key: "other",
    tabLabel: "Other documents",
    tabIcon: <DotsIcon orientation="horizontal" className="pr-1" />,
  },
];

export default documentsTabElements;
